export const hidePartialString = (str: string, subStr?: string) => {
  return `${str.slice(0, 6)}*************${str.slice(-6)}`;
};
